import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "0",
  },
  messagesList: {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    padding: "0",
    marginLeft: "0",
    marginTop: "0",
    marginBottom: "0",
    width: "100%",
  },
  emptyState: {
    textAlign: "center",
    padding: "40px 20px",
    color: "#999",
    fontSize: "14px",
  },
}));

